import Api from "../api/api";

export default async (body) => {
  const { data } = await Api.post("like", body);
  return data;
};
